import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { dealerInformationStyles } from "@insite/content-library/Widgets/DealerDetails/DealerInformation";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

import { css } from "styled-components";

dealerInformationStyles.nameGridItem = mergeToNew(dealerInformationStyles.nameGridItem, {
    width: 12,
    css: css`
        padding-left: 37px;
    `,
});

dealerInformationStyles.container = mergeToNew(dealerInformationStyles.container, {
    gap: 10,
    css: css`
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: max-content;
                        margin-bottom: 20px;
                    `,
                    null,
                    css`
                        width: 100%;
                        margin-bottom: 20px;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                ],
                "min",
            )};
    `,
});
dealerInformationStyles.selectedDealerDisplayBackToResultsGridItem = mergeToNew(
    dealerInformationStyles.selectedDealerDisplayBackToResultsGridItem,
    {
        width: 12,
        css: css`
            span:first-child {
                margin-right: 5px;
            }
        `,
    },
);

dealerInformationStyles.nameGridItem = mergeToNew(dealerInformationStyles.nameGridItem, {
    width: 12,
    css: css`
        padding-left: 37px;
    `,
});

dealerInformationStyles.addressInfoIcon = mergeToNew(dealerInformationStyles.addressInfoIcon, {
    src: "MapPin",
    color: "primary",
    css: css`
        svg {
            width: 22px;
            height: 25px;
        }
    `,
});
dealerInformationStyles.addressInfoCondensed = mergeToNew(dealerInformationStyles.addressInfoCondensed, {
    wrapper: {
        css: css`
            padding-left: 10px;
            font-style: normal;
            display: flex;
            flex-wrap: wrap;
        `,
    },
});
dealerInformationStyles.phoneGridItem = mergeToNew(dealerInformationStyles.phoneGridItem, {
    width: 12,
    css: css`
        svg {
            width: 20px;
            height: 20px;
        }
    `,
});

dealerInformationStyles.htmlContentGridItem = mergeToNew(dealerInformationStyles.htmlContentGridItem, {
    width: 12,
    css: css`
        padding-left: 37px;
    `,
});
dealerInformationStyles.googleMapsDirectionLinkGridItem = mergeToNew(
    dealerInformationStyles.googleMapsDirectionLinkGridItem,
    {
        width: 12,
        css: css`
            padding-left: 37px;
        `,
    },
);
dealerInformationStyles.visitWebsiteLinkGridItem = mergeToNew(dealerInformationStyles.visitWebsiteLinkGridItem, {
    width: 12,
});
